<div
  class="mx-xs-3 user-access-details-default-main d-flex flex-column justify-content-center align-items-center"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <ng-container *ngIf="routeType === CONSTANTS.USERS">
        <img src="assets/svg/ico-user.svg" class="user-icon" />
      </ng-container>

      <ng-container *ngIf="routeType === CONSTANTS.ISSUES">
        <img
          src="assets/svg/ico-lock-circle-outline-white.svg"
          class="lock-icon"
        />
      </ng-container>
    </div>
    <div class="text-center mb-4">
      <ng-container *ngIf="routeType === CONSTANTS.USERS">
        <h2 class="heading">{{ 'USER_PROFILE' | translate }}</h2>
        <p class="empty-box">
          {{ 'PLEASE_SELECT_A_USER_TO_DISPLAY' | translate }}
        </p>
      </ng-container>

      <ng-container *ngIf="routeType === CONSTANTS.ISSUES">
        <h2 class="heading">{{ 'LOCK_AND_DEVICE' | translate }}</h2>
        <p class="empty-box">
          {{ 'PLEASE_SELECT_A_LOCK_OR_DEVICE_TO_DISPLAY' | translate }}
        </p>
      </ng-container>
    </div>
  </div>
</div>
